<template>
    <div id="monitoring">
      <div class="more" @click="showMore"><span>更多</span></div>
      <div class="monitoring-card">
        <div class="card-item">
          <video ref="monitor" class="item-video" controls autoplay></video>
        </div>

        <div class="card-item">
          <video ref="monitor2" class="item-video" controls autoplay></video>
        </div>

        <div style="display: block;justify-items: center;align-items: center">
          <div class="card-item" style="width: 100%;height: 100%;padding:0;">
            <video class="item-video" controls="controls">
              <source src="http://jinchanhb.com:8500/image/media/jinchanhuanbao.mp4" type="video/mp4">
            </video>
            <!--<div class="item-description">
              三溪处理站
            </div>-->
          </div>
        </div>
        <!--<div class="card-item">
          <video class="item-video" controls="controls">
            <source src="http://jinchanhb.com:8500/image/media/jinchanhuanbao.mp4" type="video/mp4">
          </video>
          <div class="item-description">
            三溪村处理站
          </div>
        </div>-->
        <!--<div class="card-item">
          <video class="item-video" controls="controls">
            <source src="http://jinchanhb.com:8500/image/media/jinchanhuanbao.mp4" type="video/mp4">
          </video>
          <div class="item-description">
            西武口处理站
          </div>
        </div>-->
        <!--<div class="card-item">
          <video class="item-video" controls="controls">
            <source src="http://jinchanhb.com:8500/image/media/jinchanhuanbao.mp4" type="video/mp4">
          </video>
          <div class="item-description">
            天英处理站
          </div>
        </div>-->
        <!--<div class="card-item">
          <video class="item-video" controls="controls">
            <source src="http://jinchanhb.com:8500/image/media/jinchanhuanbao.mp4" type="video/mp4">
          </video>
          <div class="item-description">
            三溪处理站
          </div>
        </div>-->
      </div>

      <a-modal v-model="visible" title="更多监控视频" :centered="true" :width="800" @ok="handleOk">
        <div class="monitoring-card-more">
          <div class="card-item-more" v-for="(video, index) in itemVideoList" :key="video.name">
            <video class="item-video-more" controls="controls">
              <source v-bind:src="video.src" type="video/mp4">
            </video>
            <div class="item-description-more">
              {{video.name}}
            </div>
          </div>
        </div>
      </a-modal>

      <!--<a-modal v-model="videoVisible" title="德有文具" :centered="true" :width="650" :footer="null" >
        <div id="video-container1"></div>
      </a-modal>-->
    </div>
</template>

<script>
    let itemVideoList = [
      {
        src: 'http://jinchanhb.com:8500/image/media/jinchanhuanbao.mp4',
        name: '小源村处理站'
      },
      {
        src: 'http://jinchanhb.com:8500/image/media/jinchanhuanbao.mp4',
        name: '西桥村处理站'
      },
      {
        src: 'http://jinchanhb.com:8500/image/media/jinchanhuanbao.mp4',
        name: '天英村处理站'
      },
      {
        src: 'http://jinchanhb.com:8500/image/media/jinchanhuanbao.mp4',
        name: '砖山村处理站'
      },
      {
        src: 'http://jinchanhb.com:8500/image/media/jinchanhuanbao.mp4',
        name: '塘源村处理站'
      },
      {
        src: 'http://jinchanhb.com:8500/image/media/jinchanhuanbao.mp4',
        name: '东溪村处理站'
      }
    ];

    import axios from 'axios';
    import Hls from 'hls.js';

    export default {
        name: "MonitoringList",
        data(){
          return{
            visible: false,
            itemVideoList: itemVideoList,
            videoVisible: false,
            monitors: []
          }
        },
        methods: {
          showMore(){
            // this.visible = true;
          },
          handleOk(e){
            this.visible = false;
          },
          createData(){
            const params = new Object();
            params.appKey = '5857e573196b48efa8a1bed5e311e7cb';
            params.appSecret = 'd447c73fda606810cb3f4fe42fded02b';

            axios.post('https://open.ys7.com/api/lapp/token/get',{...params},{
              transformRequest: [(params) => {
                let result = '';
                Object.keys(params).forEach((key) => {
                  if (!Object.is(params[key], undefined) && !Object.is(params[key], null)) {
                    result += encodeURIComponent(key) + '=' + encodeURIComponent(params[key]) + '&'
                  }
                });
                return result;
              }],
              headers: {
                'Content-Type': 'application/x-www-form-urlencoded'
              }
            }).then((r)=>{
              let data = r.data;
              if(data.code != 200){
                this.$message.error("获取accessToken失败");
              }else {
                let accessToken = data.data.accessToken;

                axios.post('https://open.ys7.com/api/lapp/live/video/list',{accessToken: accessToken},{
                  transformRequest: [(params) => {
                    let result = '';
                    Object.keys(params).forEach((key) => {
                      if (!Object.is(params[key], undefined) && !Object.is(params[key], null)) {
                        result += encodeURIComponent(key) + '=' + encodeURIComponent(params[key]) + '&'
                      }
                    });
                    return result;
                  }],
                  headers: {
                    'Content-Type': 'application/x-www-form-urlencoded'
                  }
                }).then((r)=>{
                    let result = r.data;
                    if(result.code != 200){
                      this.$message.error("获取监控列表失败");
                    }else {
                      this.monitors = result.data;
                      this.$nextTick(function () {
                        var hls = new Hls();
                        hls.loadSource(this.monitors[0].liveAddress);//需要播放的视频地址
                        hls.attachMedia(this.$refs.monitor);
                        hls.on(Hls.Events.MANIFEST_PARSED, function() {
                          this.$refs.monitor.play();
                        });

                        var hls2 = new Hls();
                        hls2.loadSource(this.monitors[1].liveAddress);//需要播放的视频地址
                        hls2.attachMedia(this.$refs.monitor2);
                        hls2.on(Hls.Events.MANIFEST_PARSED, function() {
                          this.$refs.monitor2.play();
                        });

                      });

                    }
                  }).catch((d)=>{
                    this.$message.error("获取监控列表失败");
                })
              }
            }).catch(()=>{
              this.$message.error("获取accessToken失败");
            })
          },
          createData1(){
            this.$get('/api/dahua/accessToken').then((r)=>{
              if(r.data.code != 200){
                this.$message.error("权限不足");
              }else {
                let result = r.data.data.result;
                let accessToken = result.data.accessToken;

                this.$get('/api/dahua/liveList?accessToken='+accessToken).then((r)=>{
                  if(r.data.code != 200){
                    this.$message.error("权限不足");
                  }else {
                    let result = r.data.data.result.data;
                    let hlsUrl = "";
                    result.lives.forEach(function (item) {
                      let coverUrl = item.streams[1].coverUrl;
                      hlsUrl = item.streams[1].hls;
                    });
                    var hls3 = new Hls();
                    hls3.loadSource(hlsUrl);//需要播放的视频地址
                    hls3.attachMedia(this.$refs.monitor3);
                    hls3.on(Hls.Events.MANIFEST_PARSED, function() {
                      this.$refs.monitor3.play();
                    });
                  }
                }).catch(()=>{})
              }
            }).catch(()=>{})

          },
        },
        mounted() {
            const {createData, createData1} = this;
            createData();
            // createData1();
        }
    }
</script>

<style scoped lang="less">
    #monitoring{
      width: 100%;
      height: 100%;

      .more{
        text-align: right;
        cursor: pointer;
      }

      .monitoring-card{
        width: 100%;
        height: 100%;
        display: flex;
        flex-direction: row;
        flex-wrap: wrap;
      }

      .monitoring-card .card-item{
        width: 50%;
        height: 45%;
        flex: none;
        padding: 0 5px;
        cursor: pointer;
      }
      .item-video{
        width: 100%;
        height: 90%;
      }
      .item-description{
        text-align: center;
      }
    }

    .monitoring-card-more{
      width: 100%;
      height: 100%;
      display: flex;
      flex-direction: row;
      flex-wrap: wrap;

      .card-item-more{
        width: 33.3%;
        height: 40%;
      }

      .card-item-more .item-video-more{
        width: 100%;
        height: 90%;
        flex: none;
        padding: 0 5px;
        cursor: pointer;
      }

      .item-description-more{
        text-align: center;
      }
    }
</style>



// WEBPACK FOOTER //
// src/views/datav/MonitoringList.vue